<template>
  <div
    class="list-icon_item dropdown"
    id="navLang"
    v-if="Object.keys(availableLangs).length > 0">
    <a
      href="#"
      data-modal="timestamp"
      class="btnModal dropdown-toggle tw-text-primary-300 hover:tw-text-primary-400 tw-text-center"
      id="btnModalLang"
      data-test="open-language-selector"
      data-bs-toggle="dropdown"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
      data-tooltip="tooltip"
      data-placement="bottom"
      title="Language / Sprache">
      <FontAwesomeIcon
        v-if="props.showGenericOpener"
        icon="custom-language"
        class="tw-text-2xl tw-mt-2" />
      <div
        v-else
        class="tw-inline-block tw-w-7 tw-h-5 tw-mt-2">
        <FlagDisplay :flag="globalStore.language.toString().toLowerCase()" />
      </div>
    </a>
    <div
      class="dropdown-menu dropdown-menu-right dropdown-submenu dropdown-language tw-fixed"
      aria-labelledby="btnModalLang">
      <span class="dropdown-arrow"></span>
      <div class="dropdown-header tw-bg-primary-500 tw-text-primary-contrast">
        <FontAwesomeIcon
          icon="custom-language"
          class="tw-absolute tw-text-white tw-opacity-10 tw-text-8xl tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2" />
        <h4 v-html="t('navi.header_language_headline')"></h4>
      </div>
      <div class="dropdown-body tw-z-40">
        <div class="row">
          <div class="col-sm-12 subnavi">
            <ul class="row clearfix">
              <li
                v-for="(lang, index) in availableLangs"
                class="col-md-6"
                :class="$i18next.language === index.toString() ? 'tw-bg-primary-100' : ''"
                :key="index">
                <a
                  href="#"
                  :data-test="'language-selector-' + index.toString()"
                  @click.prevent="changeLanguage(index.toString())">
                  <div class="tw-h-8 tw-w-8 tw-rounded-full tw-overflow-hidden">
                    <FlagDisplay
                      squared
                      :flag="index.toString().toLowerCase()" />
                  </div>
                  <span>
                    {{ lang.nativeName }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import FlagDisplay from "@/components/library/FlagDisplay/FlagDisplay.vue";
import { useLanguageChanger } from "@/composables/useLanguageChanger";
import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const props = defineProps<{ showGenericOpener?: boolean }>();
const { t } = useTranslation();
const globalStore = useGlobalConfigsStore();
const { changeLanguage } = useLanguageChanger();

const availableLangs = computed(() => globalStore.availableLanguages ?? {});
</script>
